import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Config} from '@mitel/cloudlink-sdk'

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Config.global = new Config({
  appInfo: environment.appInfo,
  cloud: environment.cloud,
  requestTimeoutMilliseconds: 30000,
  stage: environment.stage as any,
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
